import * as generic from "@/store/generic/mutations/result-status.js";

export function clearError(state, payload) {
  generic.clearError(state, payload);
}

export function setError(state, payload) {
  generic.setError(state, payload);
}

export function setSuccess(state, payload) {
  generic.setSuccess(state, payload);
}

export function setProcessing(state, payload) {
  generic.setProcessing(state, payload);
}

export function setPrivateMessages(state, payload) {
  state.privateMessages = payload;
}

export function setPrivateMessagesSendTo(state, payload) {
  state.privateMessagesSendTo = payload;
}

export function setPrivateMessagesSendFrom(state, payload) {
  state.privateMessagesSendFrom = payload;
}
export function setCoursesOfPrivateMessage(state, payload) {
  state.coursesOfPrivateMessage = payload;
}
